import { render, staticRenderFns } from "./correctAnswer.vue?vue&type=template&id=06255459&"
import script from "./correctAnswer.vue?vue&type=script&lang=js&"
export * from "./correctAnswer.vue?vue&type=script&lang=js&"
import style0 from "./correctAnswer.vue?vue&type=style&index=0&id=06255459&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports